import { api } from "./client";
import type { Category, Paginated, Product, Shop } from "./types";

export const catalogApi = {
  listCategories: () => api.get<Paginated<Category>>("/categories/").then((r) => r.data),
  createCategory: (payload: Partial<Category>) =>
    api.post<Category>("/categories/", payload).then((r) => r.data),
  updateCategory: (id: string, payload: Partial<Category>) =>
    api.patch<Category>(`/categories/${id}/`, payload).then((r) => r.data),
  deleteCategory: (id: string) => api.delete(`/categories/${id}/`),

  listProducts: (params: Record<string, unknown> = {}) =>
    api.get<Paginated<Product>>("/products/", { params }).then((r) => r.data),
  createProduct: (payload: Partial<Product>) =>
    api.post<Product>("/products/", payload).then((r) => r.data),
  updateProduct: (id: string, payload: Partial<Product>) =>
    api.patch<Product>(`/products/${id}/`, payload).then((r) => r.data),
  deleteProduct: (id: string) => api.delete(`/products/${id}/`),
  bulkUploadProducts: (file: File, categoryId: string) => {
    const body = new FormData();
    body.append("file", file);
    body.append("category_id", categoryId);
    return api
      .post<{
        category: string;
        successful_rows: number;
        created_rows: number;
        updated_rows: number;
        failed_rows: number;
        errors: { row_number: number; reason: string }[];
      }>("/products/bulk-upload/", body)
      .then((r) => r.data);
  },

  listShops: (params: Record<string, unknown> = {}) =>
    api.get<Paginated<Shop>>("/shops/", { params }).then((r) => r.data),
  bulkUploadShops: (file: File) => {
    const body = new FormData();
    body.append("file", file);
    return api
      .post<{
        successful_rows: number;
        created_rows: number;
        updated_rows: number;
        failed_rows: number;
        gst_dropped: number;
        assigned_rows: number;
        unknown_employee_codes: string[];
        errors: { row_number: number; name: string; reason: string }[];
      }>("/shops/bulk-upload/", body)
      .then((r) => r.data);
  },
  createShop: (payload: Partial<Shop>) => api.post<Shop>("/shops/", payload).then((r) => r.data),
  updateShop: (id: string, payload: Partial<Shop>) =>
    api.patch<Shop>(`/shops/${id}/`, payload).then((r) => r.data),
  deleteShop: (id: string) => api.delete(`/shops/${id}/`),
};
